import moment from "moment";

const Utils = {
  // eslint-disable-next-line no-unused-vars
  install(Vue, options) {
    // javascript object deep clone
    Vue.prototype.$clone = (obj) => JSON.parse(JSON.stringify(obj));

    // parse error to string
    Vue.prototype.$parseError = (err) =>
      err.response
        ? err.response.data.message + ` (Code: ${err.response.status})`
        : err;

    // slashed format (DD/MM/YYYY) to ISO text
    Vue.prototype.$dateToISO = (date) =>
      moment(date, "DD/MM/YYYY").format("YYYY-MM-DD");

    // ISO format date to text
    Vue.prototype.$dateToText = (date) => moment(date).format("YYYY-MM-DD");

    // ISO format datetime to text
    Vue.prototype.$datetimeToText = (datetime) =>
      moment(datetime).format("YYYY-MM-DD HH:mm:SS");
  },
};

export default Utils;
